import { useState, useLayoutEffect } from 'react'

export type Dimensions = Partial<Record<'width' | 'height', string>>

const empty: Dimensions = {}

/*
 * This hook measures the dimensions of the mask area of
 * Reactour.  While this is really ugly,
 * we use requestAnimationFrame to measure
 * the SVG mask on resize so it is somewhat debounced
 * (unlike the actual Reactour size which runs on every resize!!).
 * Sadly, there seems to be no other way to fetch the dimensions.
 *
 * We then use this position to align the tooltip
 * to be centered on the mask.
 */
const useMaskSize = () => {
  const [dimensions, setDimensions] = useState(empty)
  useLayoutEffect(() => {
    let subscribed = true
    let ticking = true
    const update = () => {
      ticking = false
      if (typeof window === 'undefined') return
      const elem = document.querySelector('.tour-mask > svg > rect:last-of-type')
      const styles = elem ? window.getComputedStyle(elem) : null
      const data = styles ? { width: styles['width'], height: styles['height'] } : null
      if (subscribed && data) setDimensions(data)
    }
    const handleResize = () => {
      if (typeof window === 'undefined') return
      if (!ticking) requestAnimationFrame(update)
      ticking = true
    }
    setTimeout(update, 0)
    window.addEventListener('resize', handleResize)
    return () => {
      subscribed = false
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  return dimensions
}

export default useMaskSize
